import { render, staticRenderFns } from "./Industryknowledge.vue?vue&type=template&id=71d3ea62"
import script from "./Industryknowledge.vue?vue&type=script&lang=js"
export * from "./Industryknowledge.vue?vue&type=script&lang=js"
import style0 from "./Industryknowledge.vue?vue&type=style&index=0&id=71d3ea62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports